import React from 'react';
import AlertCard from './AlertCard';
import { Loader2, Bell, Folder } from "lucide-react";

export default function AlertList({ alerts, isLoading, selectedFolder }) {
    if (!selectedFolder) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-slate-500">
                <div className="w-20 h-20 rounded-2xl bg-slate-800/50 flex items-center justify-center mb-4">
                    <Folder className="w-10 h-10 text-slate-600" />
                </div>
                <p className="text-lg font-medium text-slate-400">Select a folder</p>
                <p className="text-sm text-slate-600 mt-1">Choose a signal system to view alerts</p>
            </div>
        );
    }

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center h-full">
                <Loader2 className="w-8 h-8 text-blue-500 animate-spin mb-4" />
                <p className="text-slate-400">Loading alerts...</p>
            </div>
        );
    }

    if (alerts.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-slate-500">
                <div className="w-20 h-20 rounded-2xl bg-slate-800/50 flex items-center justify-center mb-4">
                    <Bell className="w-10 h-10 text-slate-600" />
                </div>
                <p className="text-lg font-medium text-slate-400">No alerts available yet</p>
                <p className="text-sm text-slate-600 mt-1">Alerts will appear here when received</p>
            </div>
        );
    }

    return (
        <div className="space-y-4 p-6">
            {alerts.map(alert => (
                <AlertCard key={alert.id} alert={alert} />
            ))}
        </div>
    );
}
